import React from 'react';
import styles from './PECoatedStyleHero.module.css';

const PECoatedStyleHero = ({
  badge,
  scriptTitle,
  boldTitle,
  descriptions,
  mainImage,
  bannerImage,
}) => (
  <section className={styles.heroSection}>
    <div className={styles.container}>
      <div className={styles.contentCol}>
        <div className={styles.badgeWrapper}>
          <span className={styles.miniTag}>{badge}</span>
        </div>
        <div className={styles.titleArea}>
          <span className={styles.scriptTitle}>{scriptTitle}</span>
          <h1 className={styles.boldTitle}>{boldTitle}</h1>
        </div>
        <div className={styles.descriptionsBlock}>
          {descriptions.slice(0, 2).map((text, index) => (
            <p key={index} className={styles.heroDescription}>
              {text}
            </p>
          ))}
        </div>
        <div className={styles.bottomBannerWrapper}>
          <img src={bannerImage.src} alt={bannerImage.alt} className={styles.bottomBannerImg} />
          <div className={styles.bottomAccentShape} />
        </div>
      </div>
      <div className={styles.imageCol}>
        <div className={styles.mainImageCard}>
          <div className={styles.imageWrapper}>
            <img src={mainImage.src} alt={mainImage.alt} className={styles.mainImg} />
          </div>
          <div className={styles.orangeBackdrop} />
        </div>
        <div className={styles.dotMatrix}>
          {[...Array(24)].map((_, i) => (
            <span key={i} className={styles.dot} />
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default PECoatedStyleHero;
